import {UI} from "../../../../stem-core/src/ui/UIBase";
import {styleRuleInherit} from "../../../../stem-core/src/ui/Style";

import {Messages} from "../../../Messages";
import {registerStyle, Theme} from "../../../../stem-core/src/ui/style/Theme";
import {BlinkInput, BlinkInputStyle} from "../../../ui/Input";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {PoweredByBlink} from "../../PoweredByBlink";
import {StepDescription} from "../StepDescription";
import {authService, userService} from "../../../../client/connection/Services";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";
import {PaymentMethodStore} from "../../../State";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {AuthFlowPanel} from "../../../website/unauthenticated/slides/AuthFlowPanel.jsx";


export function donatePageOnAuthenticate(element) {
    authService.onAuthenticationChange(() => {
        if (element.isInDocument() && authService.isAuthenticated()) {
            LoadingSpinner.show();
            userService.ensureUserDataRequested(() => {
                LoadingSpinner.hide();
                if (iFrameUserDataService.getActiveRecurringDonation()) {
                    element.options.changeURL(DONATE_PAGE_URLS.recurringDonor);
                } else if (!PaymentMethodStore.getPrimary()) {
                    element.options.changeURL(DONATE_PAGE_URLS.payWithAddedCard);
                } else {
                    element.options.changeURL(DONATE_PAGE_URLS.payWithChosenCard);
                }
            });
        }
    });
}


class AuthEmailInputStyle extends BlinkInputStyle {
    @styleRuleInherit
    input = {
        marginTop: 0,
    };

    @styleRuleInherit
    inputContainer = this.themeProps.DONATE_PAGE_INPUT_CONTAINER;

    @styleRuleInherit
    label = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        marginTop: 0,
        marginBottom: 10,
    };

    @styleRuleInherit
    errorMessage = {
        top: 0,
        right: 0,
        left: "auto",
        transform: "translateY(-100%)",
    }
}

@registerStyle(AuthEmailInputStyle)
class AuthEmailInput extends BlinkInput {}


export class InlineAuthPanel extends UI.Element {
    render() {
        return [
            <StepDescription
                backFunction={() => this.options.changeURL(DONATE_PAGE_URLS.donate, true)}
                currentStep={2}
                stepDescription={Messages.authenticate}
            />,

            <MessageElement
                style={{
                    fontSize: Theme.props.MERCHANT_FONT_SIZE_LARGE,
                    textAlign: "center", margin: "0 auto 18px"
                }}
                message={Messages.merchantUsesBlinkForDonations(iFrameMerchantService.getMerchant().name)}/>,

            <AuthFlowPanel
                emailButtonLabel={Messages.continueToPayment}
                InputClass={AuthEmailInput}
                showFooter={false}/>,

            <PoweredByBlink />,
        ];
    }

    onMount() {
        super.onMount();
        donatePageOnAuthenticate(this);
    }
}
